// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
//import views from './views'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import axios from 'axios'
import 'element-ui/lib/theme-chalk/index.css'
import moment from 'moment'
import store from './store'
import md5 from 'js-md5' //md5加密
import VueClipboard from 'vue-clipboard2'
// import {post,get} from './toolJs/index'
// 引入echarts
import * as echarts from 'echarts'
// import http from './utils/http'
import {formatDate,formatDay} from './assets/js/monthday'
Vue.prototype.$get = fetch
Vue.prototype.$echarts = echarts
Vue.prototype.formatDate = formatDate
Vue.prototype.formatDay = formatDay
import './assets/css/global.css'
import SlideVerify from 'vue-monoplasty-slide-verify'
Vue.use(SlideVerify)
// import Store from './components/store'
// VueClipboard.config.autoSetContainer = true;//复制到剪切板

// 权限控制（这里没有做登陆拦截）
router.beforeEach((to, from, next) => { 
  // 根据路由元属性requiresAuth判断改路由是否需要控权限
  if (to.matched.some(item => item.meta.requiresAuth)) { 
    // 1、（首次访问页面）登录页面跳转过来、直接访问地址、刷新页面时，from.path为 "/",
    // 先请求权限接口，判断权限后再判断是否拦截
    // 2、已访问本系统但权限为空
    if (from.path === '/' || store.state.power_list.length === 0) { 
      store.dispatch('POWER_LIST').then(res => { 
        if (res.length === 0) { 
          next('/error')
        } else { 
          // 验证是否有访问该页面的权限
          store.dispatch('HAS_POWER', to).then(res => { 
            res === true ? next() : next('/error')
          })
          // 设置导航菜单选中状态
          store.commit('SELECTITEM', to)
        }
      })
    } else { 
      // 验证是否有访问该页面的权限
      store.dispatch('HAS_POWER', to).then(res => { 
        res === true ? next() : next('/error')
      })
      // 设置导航菜单选中状态
      store.commit('SELECTITEM', to)
    }
  } else { 
    next()
  }
})

// 定义一个全局过滤器实现日期格式化
Vue.filter('datefmt', function (input, fmtstring) {
  return moment.unix(input).format(fmtstring)
});
Vue.prototype.$moment = moment;
Vue.prototype.$store = store;
Vue.prototype.$md5 = md5;
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(VueClipboard);
Vue.prototype.$api = axios;
Vue.prototype.htpinfor=function(){
  return {

    // ww:'http://192.168.0.115:8890',//小周
    // ww:'http://192.168.0.133:8890',//小周

    // ww:'http://run.test.8866.ltd:8890',//内网

    // ww:'http://download.raceking.net:8890',//预发布香港
    ww:'http://gm.ollq.com:8890',//香港

  }
};
new Vue({
  el: '#app',
  router,
  store,
 // views,
  components: { App },
  template: '<App/>'
})
export default Vue



// WEBPACK FOOTER //
// ./src/main.js